import React from 'react'; 
import BarButtonFw, {BUTTON_DEFAULT} from '../../../framework/bar-button/BarButtonFw';

import FormFw from '../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT} from '../../../framework/grid/GridFw';
import { BasePage } from "../../../framework/pages/BasePage";
import { UserUtil } from '../../../util/UserUtil'; 

export class PlanProcedimientoAdminPage extends BasePage {
    createPageProperties = (pageApi) => {
        return {
            title: 'Plan Procedimiento',
            icon: 'icon-menu',
            barHeader: {
                fields: [
                    { ...BUTTON_DEFAULT.NEW, label: 'Nuevo Plan Procedimiento', type:'primary', link: '/plan-procedimiento/plan-procedimiento/new' },
                ]
            }
        };
    };

    renderPage(pageApi) {
        const getGrid = () => pageApi.getComponent('grid');
        const getForm = () => pageApi.getComponent('form'); 

        const formConfig = {
            // title: ' ',
            fields: [  
                {
                type: "select",
                name: "id_tipo_cadena",
                label: "Matriz",
                column: 4,
                load: { queryId: 905  },
                search: true,
                },  
            ],
        };

        const barButtonconfig = {
            fields: [
                { ...BUTTON_DEFAULT.SEARCH, onClick: () => getGrid().load({ params: getForm().getData() }) },
                { ...BUTTON_DEFAULT.CLEAR, onClick: () => getForm().reset() }
            ]
        };

        const gridConfig = {
            showIndex: true,
            autoLoad: true,
            pagination: { server: true },
            load: {
                queryId: 904,
            },
            fields: [
                { name: 'desc_plan', label: 'Plan Procedimiento' },
                { name: 'desc_mat', label: 'Matriz' }, 
                { ...COLUMN_DEFAULT.EDIT, label: 'Opciones',  colSpan: 2, link: (value, row, index) => `/plan-procedimiento/plan-procedimiento/${row.id_plan}/update` },
                { ...COLUMN_DEFAULT.DELETE, colSpan: 0,
                    process: {
                        fnOk: (result) => getGrid().load({ params: getForm().getData() }),
                        filter: (value, row, index) => ({ queryId: 909, params: { id_user: UserUtil.getUserId(),id_plan: row.id_plan } })
                    }
                },

            ]
        };

        return (
            <>
                <FormFw
                    name="form"
                    getParentApi={pageApi.getApi}
                    config={formConfig} />

                <BarButtonFw
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfig} />
                    
                <GridFw
                    name="grid"
                    getParentApi={pageApi.getApi}
                    config={gridConfig} />
            </>
        );

    }
}
